import Settings from "Data/Settings";
import { Sine, TimelineLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import {DWELL_DURATION} from "Data/Constants";
import { Button } from "GameObjects/UI/Button";
import { LayoutButton } from "GameObjects/UI/LayoutButton";

/** Horizontal toggle switch */
export class LayoutToggleButton extends LayoutButton {

    protected dwellTimeline?: TimelineLite;
    protected isCursorDwelling: boolean = false;
    protected _toggleValue: boolean = false;

    protected _disabledHoverVo: string;
    protected _enabledHoverVo: string;

    constructor(
        pCallback: () => void,
        pHoverVO: {on: string, off: string},
        pClickedSFX: string,
    ) {
        super(pCallback, pHoverVO.on, pClickedSFX);
        this.setLayoutTexture("cyberchase-settings-toggle-off", 0.5, 0.5);
        this._enabledTexture = HLF.PixiUtils.getTexture( "cyberchase-settings-toggle-off" );
        this._disabledTexture = HLF.PixiUtils.getTexture( "cyberchase-settings-toggle-on" );
        this._enabledHoverVo = pHoverVO.on;
        this._disabledHoverVo = pHoverVO.off;
    }

    public get toggleValue(): boolean {
        return this._toggleValue;
    }

    public setToggleValue(pValue: boolean) {
        if (pValue === true) {
            this._image!.texture = this._disabledTexture!;
            this.hoverVO = this._enabledHoverVo;
        }
        else {
            this._image!.texture = this._enabledTexture!;
            this.hoverVO = this._disabledHoverVo;
        }
        this._toggleValue = pValue;
    }

}
